import { QueryClient } from '@tanstack/react-query';
import { Queue } from '@rossum/api-client/queues';
import { QUERY_KEY_QUEUES_UNPAGINATED } from './useUnpaginatedQueues';

export const addQueueMutation = (queryClient: QueryClient, queue: Queue) => {
  queryClient.setQueriesData<Queue[] | undefined>(
    [QUERY_KEY_QUEUES_UNPAGINATED],
    prev => {
      return prev?.concat(queue);
    }
  );
};
